import { connect } from 'react-redux';
import * as React from 'react';
import { Redirect, Link } from 'react-router-dom';
import Expenses from '../expenses/container';
import Accounts from '../accounts/container';

export default props => (
  <div>
    <Expenses location={props.location} history={props.history} />
    <br />
    <Accounts location={props.location} history={props.history} showDiff={true} />
    <br />
    <br />
    <div className="fixed-action-btn">
      <div className="center-align">
        <Link to="/add-expense">
          <a className="btn-floating btn-large waves-effect waves-light light-blue darken-3">
            <i className="material-icons">add</i>
          </a>
        </Link>
      </div>
    </div>
  </div>
);



// WEBPACK FOOTER //
// ./src/dashboard/component.tsx